import { useState, type FormEvent } from 'react';
import { ApiRequestError, postJson, useAuth, type TokenResponse } from '../../api/auth.ts';
import { Banner, Button } from '../../components/ui.tsx';
import { t } from '../../i18n/index.ts';
import { inputClass } from './TotpSetup.tsx';

/** emergency login on the Pi with the recovery password from the device passport (ADR-0016) */
export function RecoveryLogin({ onBack }: { onBack(): void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(undefined);
    try {
      useAuth.getState().adopt(await postJson<TokenResponse>('/auth/recovery', { password }));
    } catch (e) {
      setError(e instanceof ApiRequestError ? e.message : t('common.error'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="space-y-4" noValidate>
      <h1 className="text-xl font-semibold">{t('recovery.title')}</h1>
      <p className="text-sm text-muted">{t('recovery.text')}</p>
      {error && <Banner tone="danger" title={error} />}
      <label className="block">
        <span className="text-sm text-muted">{t('recovery.password')}</span>
        <input
          className={`${inputClass} font-mono tracking-wider uppercase`}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="off"
          autoCapitalize="characters"
          spellCheck={false}
          placeholder="XXXX-XXXX-XXXX"
        />
      </label>
      <Button type="submit" className="w-full" disabled={busy || !password.trim()}>
        {t('recovery.submit')}
      </Button>
      <Button variant="ghost" className="w-full" onClick={onBack}>
        {t('recovery.back')}
      </Button>
    </form>
  );
}
